import { render } from "./MemberItem.vue?vue&type=template&id=435d56b8&scoped=true"
import script from "./MemberItem.vue?vue&type=script&lang=js"
export * from "./MemberItem.vue?vue&type=script&lang=js"

import "./MemberItem.vue?vue&type=style&index=0&id=435d56b8&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435d56b8"]])

export default __exports__